import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Twitter from '@mui/icons-material/Twitter';
import Instagram from '@mui/icons-material/Instagram';
import LinkedIn from '@mui/icons-material/LinkedIn';
import { ThemeContext } from '../providers/ThemeContext';
import useWindowDimensions from '../hooks/dimension';

interface MyFooterProps {

}

const MyFooter: React.FunctionComponent<MyFooterProps> = () => {

    const { darkMode } = React.useContext(ThemeContext);
    const { height, width } = useWindowDimensions();

    const date = new Date().getFullYear()

    return (
        <footer style={{
            background: darkMode ? '#212121' : 'olive',
            paddingBottom: (width && width > 600) ? 0 : 15
        }}>
            <Container >
                <Toolbar style={{
                    flexDirection: (width && width > 600) ? 'row' : 'column-reverse',
                }}>
                    <Typography variant='caption' component='div' sx={{ flexGrow: 1 }} style={{ fontSize: 14, color: 'white' }}>
                        Copyright © {date} Edi Murwanto
                    </Typography>
                    <div style={{ color: 'white' }}>
                        <IconButton
                            href='https://www.instagram.com/edhimurwanto_/'
                            size='large'
                            aria-label='instagram'
                            aria-controls='menu-appbar'
                            aria-haspopup='true'
                            color='inherit'
                        >
                            <Instagram />
                        </IconButton>
                        <IconButton
                            href='https://www.twitter.com/edhimurwanto_/'
                            size='large'
                            aria-label='twitter'
                            aria-controls='menu-appbar'
                            aria-haspopup='true'
                            color='inherit'
                        >
                            <Twitter />
                        </IconButton>
                        <IconButton
                            href='https://www.linkedin.com/in/edhimurwanto/'
                            size='large'
                            aria-label='twitter'
                            aria-controls='menu-appbar'
                            aria-haspopup='true'
                            color='inherit'
                        >
                            <LinkedIn />
                        </IconButton>
                    </div>
                </Toolbar>
            </Container>
        </footer>
    );
}

export default MyFooter;


